<template>
  <div class='animated fadeIn'>
    <b-row class='justify-content-center'>
      <b-col sm='12' lg='10'>
        <b-card no-body class='shadow-sm p-0 mb-2 bg-white rounded'>
          <b-alert variant='white' show>
            <div align='center'>
              <b-btn class='submit-btn' variant='outline-danger' v-b-modal.modal-center>提出</b-btn>
              <b-modal id='modal-center'
                      ref='modal'
                      title='提出'
                      @ok='submitOk'
                      centered
                      header-bg-variant='danger'
                      body-text-variant='danger'
                      ok-variant='danger'
                      size='sm'
                      class='px100-btn'
                      >
                <p class='my-4'>ルーティン {{ dateString(2 - dateButton) }} 日分を提出します</p>
                <p class='my-4'>よろしいですか?</p>
              </b-modal>
            </div>
          </b-alert>

          <b-alert variant='white' show>
            <div align='center'>
              <b-button-group size='sm'>
                <b-button class='date-btn' :pressed='dateButton === 0' variant='outline-danger'  v-on:click='selectDate(0)'>前々日 {{ dateString(2) }}</b-button>
                <b-button class='date-btn' :pressed='dateButton === 1' variant='outline-danger' v-on:click='selectDate(1)'>前日 {{ dateString(1) }}</b-button>
                <b-button class='date-btn' :pressed='dateButton === 2' variant='outline-danger' v-on:click='selectDate(2)'>当日 {{ dateString(0) }}</b-button>
              </b-button-group>
            </div>
          </b-alert>

          <b-alert variant='white' show>
            <div align='center'>
              <b-button-group size='sm'>
                <b-button class='filter-btn' :pressed='filterButton === 0' variant='outline-danger' v-on:click='selectFilter(0)'>全表示</b-button>
                <b-button class='filter-btn' :pressed='filterButton === 1' variant='outline-danger' v-on:click='selectFilter(1)'>/</b-button>
                <b-button class='filter-btn' :pressed='filterButton === 2' variant='outline-danger' v-on:click='selectFilter(2)'>X</b-button>
                <b-button class='filter-btn' :pressed='filterButton === 3' variant='outline-danger' v-on:click='selectFilter(3)'>○</b-button>
              </b-button-group>
            </div>
          </b-alert>
        </b-card>

        <div v-for='routine in myRoutines[dateButton]' :key='routine.key'>
          <div v-if='checkFilter(routine.routine)'>
            <b-card class='p-0 mb-2'>
              <b-card-header header-bg-variant='primary' header-text-variant="white">
                <div class='d-flex flex-row'>
                  <div><b-img :src='routine.typeBody.icon' width='30' height='30'></b-img></div>
                  <div class='p-1'>[{{ categoryText(routine.routine.category) }}]</div>
                  <div class='p-1'>{{ routine.routine.title }}</div>
                </div>
              </b-card-header>
              <b-list-group flush>
                <b-list-group-item v-if=routine.routine.mediaLink>{{ routine.routine.subTitle }}</b-list-group-item>
                <b-list-group-item v-if=routine.routine.mediaLink>
                  <b-embed align='center'
                          type='iframe'
                          aspect='16by9'
                          :src=youtube(routine.routine.mediaLink)
                          allowfullscreen
                  ></b-embed>
                </b-list-group-item>
                <b-list-group-item align='center'>
                  <b-button-group size='sm'>
                    <b-button class='select-btn' :pressed='checkRoutine(routine.routine, 0)' v-on:click='rowClicked(routine.routine, 0)' variant='outline-primary'>/</b-button>
                    <b-button class='select-btn' :pressed='checkRoutine(routine.routine, 1)' v-on:click='rowClicked(routine.routine, 1)' variant='outline-primary'>X</b-button>
                    <b-button class='select-btn' :pressed='checkRoutine(routine.routine, 2)' v-on:click='rowClicked(routine.routine, 2)' variant='outline-primary'>○</b-button>
                  </b-button-group>
                </b-list-group-item>
              </b-list-group>
            </b-card>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-row class='justify-content-center mb-3'>
      <b-col md='12' lg='10'>
        <div v-for='routine in myRoutineSelfByDate[dateButton]' :key='routine.key'>
          <div v-if='checkFilter(routine.routine)'>
            <b-card class='p-0 mb-2'>
              <b-card-header header-bg-variant='success' :header='routineTitle(routine.routine)'></b-card-header>
              <b-list-group flush>
                <b-list-group-item align='center'>
                  <b-button-group size='sm'>
                    <b-button class='select-btn' :pressed='checkRoutine(routine.routine, 0)' v-on:click='rowClicked(routine.routine, 0)' variant='outline-success'>/</b-button>
                    <b-button class='select-btn' :pressed='checkRoutine(routine.routine, 1)' v-on:click='rowClicked(routine.routine, 1)' variant='outline-success'>X</b-button>
                    <b-button class='select-btn' :pressed='checkRoutine(routine.routine, 2)' v-on:click='rowClicked(routine.routine, 2)' variant='outline-success'>○</b-button>
                  </b-button-group>
                </b-list-group-item>
              </b-list-group>
            </b-card>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import moment from 'moment'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      routinesFields: {
        title: {
          label: 'routine',
          class: 'text-center'
        },
        category: {
          label: 'category',
          class: 'text-center'
        },
        subTitle: {
          label: 'description',
          class: 'text-center'
        },
        mediaLink: {
          label: 'youTube',
          class: 'text-center'
        },
        button: {
          label: 'Action',
          class: 'text-center'
        }
      },
      buttons: {},
      dateButton: 2,
      filterButton: 0,
      myRoutinesBelongs: [],
      myRoutines: [[], [], []],
      myRoutineData: [],
      myRoutineDataByDate: [[], [], []],
      myRoutineSelfByDate: [[], [], []],
      unwatch1: null,
      unwatch8: null,
      unwatch9: null,
      unwatch10: null,
      load: null
    }
  },
  beforeDestroy () {
    if (this.unwatch1) {
      this.unwatch1()
      this.unwatch1 = null
    }
    if (this.unwatch8) {
      this.unwatch8()
      this.unwatch8 = null
    }
    if (this.unwatch9) {
      this.unwatch9()
      this.unwatch9 = null
    }
    if (this.unwatch10) {
      this.unwatch10()
      this.unwatch10 = null
    }
  },
  created () {
    if (!this.init || !this.data) {
      this.$store.dispatch('dispatch/setLoading', true)
    } else {
      this.getBelongs()
      this.setRoutineDataByDate()
      this.setRoutineSelfByDate()
      this.watch()
    }

    if (!this.init) {
      this.unwatch8 = this.$store.watch(
        state => this.$store.getters['authUser/init'],
        value => {
          if (value) {
            this.getUserData()
          }
        }
      )
    } else if (!this.data) {
      this.getUserData()
    }

    this.unwatch9 = this.$store.watch(
      state => this.$store.getters['dispatch/data'],
      value => {
        if (this.init && this.data) {
          this.$store.dispatch('dispatch/setLoading', false)
          this.watch()
        }
      }
    )

    this.unwatch10 = this.$store.watch(
      state => this.$store.getters['routineData/routineData'],
      value => {
        this.getBelongs()
        this.setRoutineDataByDate()
        this.setRoutineSelfByDate()
      }
    )
  },
  methods: {
    watch () {
      this.unwatch1 = this.$watch((vm) => [vm.$store.getters['routine/routines'],
        vm.$store.getters['routineGroup/routineGroups'],
        vm.$store.getters['routineRef/routineRefs'],
        vm.$store.getters['service/services'],
        vm.$store.getters['group/groups'],
        vm.$store.getters['authUser/user'],
        vm.$store.getters['routineData/routineData'],
        vm.$store.getters['routineSelf/routineSelf']], function () {
        this.getBelongs()
        this.setRoutineDataByDate()
        this.setRoutineSelfByDate()
      })
    },
    getUserData () {
      this.$store.dispatch('routineData/init')
      this.$store.dispatch('routineData/subscribe').then(() => {
        this.getBelongs()
        this.setRoutineDataByDate()
        this.setRoutineSelfByDate()
        this.$store.dispatch('dispatch/setData', true)
      })
    },
    dateString (diff) {
      var objDate = new Date()
      objDate.setDate(objDate.getDate() - diff)
      return moment(objDate).format('MM/DD')
    },
    setRoutines (type, key, owner) {
      var vm = this
      var typeBody = null
      var index = null
      if (type === 'service') {
        index = this.services.findIndex(service => service.key === owner)
        typeBody = this.services[index]
      } else if (type === 'group') {
        index = this.groups.findIndex(service => service.key === owner)
        typeBody = this.groups[index]
      } else {
        typeBody = this.user
      }
      index = vm.routineRefs.findIndex(ref => ref.key === key)
      if (index !== -1) {
        var refKey = this.routineRefs[index].routine_ref
        var startAt = this.routineRefs[index].startAt
        var endAt = this.routineRefs[index].endAt

        const gIndex = this.routineGroups.findIndex(group => group.key === refKey)
        for (var z = 0; z < this.routineGroups[gIndex].routines.length; z++) {
          index = this.routines.findIndex(
            routine => routine.key === this.routineGroups[gIndex].routines[z]
          )
          if (index !== -1) {
            const payload = {
              type: type,
              typeBody: typeBody,
              startAt: startAt,
              endAt: endAt,
              routine: this.routines[index]
            }

            var objDate = new Date()
            var str = moment(objDate).format('YYYY/MM/DD')
            var state = { date: str }
            var today = parseInt(moment(Date.parse(state.date)).format('X'))

            if (startAt <= today - 86400 * 2 && endAt >= today - 86400 * 2) {
              this.myRoutines[0].push(payload)
            }
            if (startAt <= today - 86400 && endAt >= today - 86400) {
              this.myRoutines[1].push(payload)
            }
            if (startAt <= today && endAt >= today) {
              this.myRoutines[2].push(payload)
            }
          }
        }
      }
      this.myRoutines.sort(function (a, b) {
        if (a.createdAt < b.createdAt) return -1
        if (a.createdAt > b.createdAt) return 1
        return 0
      })
    },
    getBelongs () {
      if (!this.user) {
        return
      }
      var keys = Object.keys(this.user.services)
      var index = this.services.findIndex(service => service.key === keys[0])
      if (index !== -1) {
        this.service = this.services[index]
      }

      this.myRoutines = [[], [], []]
      this.myRoutinesBelongs = []
      for (var value in this.user.services) {
        if (this.user.services[value]) {
          const index = this.services.findIndex(service => service.key === value)
          if (index !== -1) {
            var service = this.services[index]
            for (var i = 0; i < service.routine.length; i++) {
              this.setRoutines('service', service.routine[i], value)
            }
          }
        }
      }
      for (value in this.user.groups) {
        if (this.user.groups[value]) {
          const index = this.groups.findIndex(group => group.key === value)
          if (index !== -1) {
            var group = this.groups[index]
            for (i = 0; i < group.routine.length; i++) {
              this.setRoutines('group', group.routine[i], value)
            }
          }
        }
      }
      if (this.user.routine) {
        for (i = 0; i < this.user.routine.length; i++) {
          this.setRoutines('user', this.user.routine[i], this.user.key)
        }
      }
    },
    setRoutineSelfByDate () {
      this.myRoutineSelfByDate = [[], [], []]
      var objDate = new Date()
      objDate.setDate(objDate.getDate() - 1)
      var str = moment(objDate).format('YYYY/MM/DD')
      var state = { date: str }
      var day1 = parseInt(moment(Date.parse(state.date)).format('X'))

      objDate = new Date()
      objDate.setDate(objDate.getDate() - 0)
      str = moment(objDate).format('YYYY/MM/DD')
      state = { date: str }
      var day0 = parseInt(moment(Date.parse(state.date)).format('X'))

      objDate = new Date()
      objDate.setDate(objDate.getDate() + 1)
      str = moment(objDate).format('YYYY/MM/DD')
      state = { date: str }
      var day1p = parseInt(moment(Date.parse(state.date)).format('X'))

      for (var i = 0; i < this.routineSelf.length; i++) {
        const payload = {
          type: 'self',
          typeBody: null,
          startAt: this.routineSelf[i].startAt,
          endAt: null,
          routine: this.routineSelf[i]
        }
        // var payload = this.myRoutineSelf[i]
        if (payload.routine.done === false) {
          // var today = new Date() / 1000
          if (payload.startAt < day1) {
            this.myRoutineSelfByDate[0].push(payload)
          }
          if (payload.startAt < day0) {
            this.myRoutineSelfByDate[1].push(payload)
          }
          if (payload.startAt < day1p) {
            this.myRoutineSelfByDate[2].push(payload)
          }
        }
      }
    },
    setRoutineDataByDate () {
      this.myRoutineDataByDate = [[], [], []]
      var objDate = new Date()
      objDate.setDate(objDate.getDate() - 2)
      var str = moment(objDate).format('YYYY/MM/DD')
      var state = { date: str }
      var day2 = parseInt(moment(Date.parse(state.date)).format('X'))

      objDate = new Date()
      objDate.setDate(objDate.getDate() - 1)
      str = moment(objDate).format('YYYY/MM/DD')
      state = { date: str }
      var day1 = parseInt(moment(Date.parse(state.date)).format('X'))

      objDate = new Date()
      objDate.setDate(objDate.getDate())
      str = moment(objDate).format('YYYY/MM/DD')
      state = { date: str }
      var day0 = parseInt(moment(Date.parse(state.date)).format('X'))

      for (var i = 0; i < this.routineData.length; i++) {
        var payload = this.routineData[i]
        if (payload.date === day2) {
          this.myRoutineDataByDate[0].push(payload)
        }
        if (payload.date === day1) {
          this.myRoutineDataByDate[1].push(payload)
        }
        if (payload.date === day0) {
          this.myRoutineDataByDate[2].push(payload)
        }
      }
      var data = this.myRoutineDataByDate[this.dateButton]
      this.buttons = {}
      for (i = 0; i < data.length; i++) {
        var keys = Object.keys(data[i].routineService)
        for (var k = 0; k < keys.length; k++) {
          var rKeys = Object.keys(data[i].routineService[keys[k]])
          for (var r = 0; r < rKeys.length; r++) {
            this.buttons[rKeys[r]] = data[i].routineService[keys[k]][rKeys[r]]
          }
        }
        keys = Object.keys(data[i].routineGroup)
        for (k = 0; k < keys.length; k++) {
          rKeys = Object.keys(data[i].routineGroup[keys[k]])
          for (r = 0; r < rKeys.length; r++) {
            this.buttons[rKeys[r]] = data[i].routineGroup[keys[k]][rKeys[r]]
          }
        }
        keys = Object.keys(data[i].routineUser)
        for (k = 0; k < keys.length; k++) {
          this.buttons[keys[k]] = data[i].routineUser[keys[k]]
        }
        keys = Object.keys(data[i].routineSelf)
        for (k = 0; k < keys.length; k++) {
          this.buttons[keys[k]] = data[i].routineSelf[keys[k]]
        }
      }
    },
    selectDate (id) {
      this.dateButton = id
      this.setRoutineDataByDate()
    },
    selectFilter (id) {
      this.filterButton = id
    },
    checkFilter (routine) {
      if (this.filterButton === 0) {
        return true
      }
      if (this.filterButton === 1) {
        if (this.buttons[routine.key] === 0) {
          return true
        } else {
          return false
        }
      }
      if (this.filterButton === 2) {
        if (this.buttons[routine.key] === 1) {
          return true
        } else {
          return false
        }
      }
      if (this.filterButton === 3) {
        if (this.buttons[routine.key] === 2) {
          return true
        } else {
          return false
        }
      }
    },
    youtube (id) {
      return 'https://www.youtube.com/embed/' + id
    },
    checkRoutine (routine, id) {
      if (this.buttons[routine.key]) {
        if (this.buttons[routine.key] === id) {
          return true
        } else {
          return false
        }
      } else {
        this.buttons[routine.key] = 0
        if (this.buttons[routine.key] === id) {
          return true
        } else {
          return false
        }
      }
    },
    submitOk () {
      var vm = this
      var serviceCounter = [0, 0, 0]
      var groupCounter = [0, 0, 0]
      var userCounter = [0, 0, 0]
      var selfCounter = [0, 0, 0]
      var totalCounter = [0, 0, 0]
      var service = {}
      var group = {}
      var user = {}
      var self = {}

      for (var index in this.myRoutines[this.dateButton]) {
        var payload = this.myRoutines[this.dateButton][index]
        var key = payload.typeBody.key
        var routineKey = payload.routine.key
        if (payload.type === 'service') {
          serviceCounter[this.buttons[routineKey]] += 1
          if (service[key]) {
            service[key][routineKey] = this.buttons[routineKey]
          } else {
            service[key] = {}
            service[key][routineKey] = this.buttons[routineKey]
          }
        }
        if (payload.type === 'group') {
          groupCounter[this.buttons[routineKey]] += 1
          if (group[key]) {
            group[key][routineKey] = this.buttons[routineKey]
          } else {
            group[key] = {}
            group[key][routineKey] = this.buttons[routineKey]
          }
        }
        if (payload.type === 'user') {
          userCounter[this.buttons[routineKey]] += 1
          user[routineKey] = this.buttons[routineKey]
        }
      }
      for (index in this.myRoutineSelfByDate[this.dateButton]) {
        payload = this.myRoutineSelfByDate[this.dateButton][index]
        routineKey = payload.routine.key
        selfCounter[this.buttons[routineKey]] += 1
        self[routineKey] = this.buttons[routineKey]
      }

      totalCounter[0] =
        serviceCounter[0] + groupCounter[0] + userCounter[0] + selfCounter[0]
      totalCounter[1] =
        serviceCounter[1] + groupCounter[1] + userCounter[1] + selfCounter[1]
      totalCounter[2] =
        serviceCounter[2] + groupCounter[2] + userCounter[2] + selfCounter[2]

      var routineCounter = {
        total: {
          none: totalCounter[0],
          undone: totalCounter[1],
          done: totalCounter[2]
        },
        service: {
          none: serviceCounter[0],
          undone: serviceCounter[1],
          done: serviceCounter[2]
        },
        group: {
          none: groupCounter[0],
          undone: groupCounter[1],
          done: groupCounter[2]
        },
        user: {
          none: userCounter[0],
          undone: userCounter[1],
          done: userCounter[2]
        },
        self: {
          none: selfCounter[0],
          undone: selfCounter[1],
          done: selfCounter[2]
        }
      }

      payload = {}
      key = null
      if (this.myRoutineDataByDate[this.dateButton][0]) {
        var data = this.myRoutineDataByDate[this.dateButton][0]
        key = data.key
        payload = {
          owner: data.owner,
          date: data.date,
          dateText: data.dateText,
          routineCounter: routineCounter,
          routineService: service,
          routineGroup: group,
          routineUser: user,
          routineSelf: self,
          createdAt: data.createdAt,
          updatedAt: parseInt(new Date().getTime() / 1000)
        }
      } else {
        var objDate = new Date()
        objDate.setDate(objDate.getDate() - (2 - this.dateButton))
        var strDate = moment(objDate).format('YYYY/MM/DD')
        var intDate = parseInt(moment(strDate).format('X'))
        payload = {
          owner: this.user.key,
          date: intDate,
          dateText: strDate,
          routineCounter: routineCounter,
          routineService: service,
          routineGroup: group,
          routineUser: user,
          routineSelf: self,
          createdAt: parseInt(new Date().getTime() / 1000),
          updatedAt: parseInt(new Date().getTime() / 1000)
        }
      }
      const db = firebase.firestore()
      const settings = { timestampsInSnapshots: true }
      db.settings(settings)
      var batch = db.batch()
      var refUser = null
      if (key) {
        refUser = db
          .collection('routine_data')
          .doc(payload.owner)
          .collection('data')
          .doc(key)
      } else {
        refUser = db
          .collection('routine_data')
          .doc(payload.owner)
          .collection('data')
          .doc()
      }
      batch.set(refUser, payload)

      batch.commit().then(function () {
        vm.$refs.modal.hide()
      })
    },
    rowClicked (routine, id) {
      var temp = this.buttons
      this.buttons = {}
      temp[routine.key] = id
      this.buttons = temp
    },
    routineTitle (routine) {
      var str = ''
      if (routine !== null) {
        str = '[' + this.categoryText(routine.category) + '] ' + routine.title
      }
      return str
    },
    headerVariant (routine) {
      if (routine.category === 'None') {
        return 'default'
      }
      if (routine.category === 'Mental') {
        return 'danger'
      }
      if (routine.category === 'Skill') {
        return 'warning'
      }
      if (routine.category === 'Health') {
        return 'success'
      }
      if (routine.category === 'Living') {
        return 'primary'
      }
    }
  },
  computed: {
    ...mapGetters({
      routines: 'routine/routines',
      routineGroups: 'routineGroup/routineGroups',
      routineRefs: 'routineRef/routineRefs',
      routineSelf: 'routineSelf/routineSelf',
      routineData: 'routineData/routineData',
      services: 'service/services',
      groups: 'group/groups',
      user: 'authUser/user',
      data: 'dispatch/data',
      register: 'register/register',
      init: 'authUser/init'
    })
  },
  filters: {
    moment: function (date) {
      return moment(date).format('YYYY/MM/DD HH:mm')
    },
    momentShort: function (date) {
      return moment(date).format('YYYY/MM/DD')
    },
    momentMMDD: function (date) {
      return moment(date).format('MM/DD')
    }
  }
}
</script>

<style lang='scss'>
// .btn{width:60px;}
.select-btn {
  width: 60px;
}
.date-btn {
  width: 74px;
  white-space: normal;
}
.px100-btn {
  width: 100px;
}
.filter-btn {
  width: 60px;
}
.submit-btn {
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/Check.vue